export const mobile = 360
export const tabletVertical = 768
export const desktopSmall = 940
export const tabletHorizontal = 1024
export const desktopLarge = 1440
